<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin: 15%; position: relative;">
                            <CContainer>
                                <h1 class="font-general-sans text-center custom-54px-400 text-white" data-aos="fade-left">
                                    AI-Driven Police <br /> Reporting & Investigation System
                                </h1>
                                <p class="text-white text-center">Leverage AI and facial recognition to enhance police reporting, improve case tracking, and streamline investigations.</p>
                                <div class="text-center">
                                    <CButton class="b-20 bg-white">Submit complaint</CButton>
                                    <CButton class="b-20 button-transparent text-white ml-2">Learn How AI Helps</CButton>
                                </div>
                            </CContainer>
                        </div>
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
        <!-- new color header -->
        <CCol sm="12" style="background-size: cover;background:#26224E" :style="{ backgroundImage: `url(${backgroundUrlBox})` }">
            <br />   <br />
            <CRow class="p-2">
                <CCol sm="6" style="border-right:1px dashed #fff;border-bottom:1px dashed #fff">
                        <div class="text-center m-3">
                            <img src="../assets/img/all/c1.png" width="50px"/>
                            <p class="custom-24px-400 text-white mt-4">AI-Powered <br />Report Assistance</p>
                            <p class="custom-18px-400 font-color-D2D6DB">AI processes submitted complaints efficiently.</p>
                        </div>
                        <br />   <br />
                </CCol>
                <CCol sm="6" style="border-bottom:1px dashed #fff">
                    <div class="text-center m-3">
                            <img src="../assets/img/all/c2.png" width="50px"/>
                            <p class="custom-24px-400 text-white mt-4">Face Reaction <br />Tracking</p>
                            <p class="custom-18px-400 font-color-D2D6DB">AI detects emotional cues for more accurate investigations</p>
                        </div>
                        <br />   <br />
                </CCol>
                <CCol sm="6" style="border-right:1px dashed #fff;">
                        <div class="text-center m-3">
                            <img src="../assets/img/all/c3.png" width="50px"/>
                            <p class="custom-24px-400 text-white mt-4">Secure & Transparent Case Tracking</p>
                            <p class="custom-18px-400 font-color-D2D6DB">Users can follow up on their reports.
</p>
                        </div>
                        <br />   <br />
                </CCol>
                <CCol sm="6">
                    <div class="text-center m-3">
                            <img src="../assets/img/all/c3.png" width="50px"/>
                            <p class="custom-24px-400 text-white mt-4">Advanced Crime Data Analytics</p>
                            <p class="custom-18px-400 font-color-D2D6DB">AI identifies patterns in investigations.</p>
                        </div>
                        <br />   <br />
                </CCol>
            </CRow>
            <br />   <br />
        </CCol>

    
        <CCol sm="12" class="bg-white">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" class="responsive-90">
                        <div class="text-center">
                            <br />
                            <h1 class="custom-text-aladdin text-black poppin-font text-48px" data-aos="slide-up">
                                How AI is Helping Police Reports
                            </h1>
                            <p class="custom-16px-400 text-center ml-4" data-aos="zoom-out">Get to know the AI helping others</p>
    
                            <br />
                            <CContainer>
                            <CRow style="margin-left:3%;margin-right:3%" class="d-sm-down-none">
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/all/ai1.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        AI-Assisted Complaint Submission
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Using artificial intelligence, this system automatically extracts important information from the reports submitted by users. This process ensures that the reports are more organized, reducing…
                                    </p>
                                    <div class="text-left">
                                    <CButton class="b-20 button-transparent-171717 font-color-171717">Learn More <img src="../assets/img/smallicon/export.png" width="20px" /></CButton>
                                </div>
                                </CCol>
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Real-Time Case Tracking
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Users can easily monitor the progress of their reports through the AI-based tracking system. Any status changes or updates will be available in real-time, enhancing transparency and certainty in the case resolutio</p>
                                        <div class="text-left">
                                    <CButton class="b-20 button-transparent-171717 font-color-171717">Learn More <img src="../assets/img/smallicon/export.png" width="20px" /></CButton>
                                </div>
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/all/ai2.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/all/ai3.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Smart Crime Analytics
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        AI analyzes incoming report data to identify crime patterns and trends more accurately. With this technology, law enforcement can optimize prevention strategies and responses to crime based on data-driven insi</p>
                                        <div class="text-left">
                                    <CButton class="b-20 button-transparent-171717 font-color-171717">Learn More <img src="../assets/img/smallicon/export.png" width="20px" /></CButton>
                                </div>
                                </CCol>
    
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Face Reaction Tracking
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Using facial expression monitoring technology, AI can analyze users' emotional reactions while making reports. This system helps detect inconsistencies or potential manipulation of information, thereby impro</p>
                                        <div class="text-left">
                                    <CButton class="b-20 button-transparent-171717 font-color-171717">Learn More <img src="../assets/img/smallicon/export.png" width="20px" /></CButton>
                                </div>
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/all/ai4.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
                            </CRow>
                            </CContainer>
    
                            <CRow class="d-md-none">
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/all/ai1.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        AI-Assisted Complaint Submission
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Using artificial intelligence, this system automatically extracts important information from the reports submitted by users. This process ensures that the reports are more organized, reducing…
                                    </p>
                                    <div class="text-left">
                                    <CButton class="b-20 button-transparent-171717 font-color-171717">Learn More <img src="../assets/img/smallicon/export.png" width="20px" /></CButton>
                                </div>
    
                                </CCol>
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Real-Time Case Tracking
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Users can easily monitor the progress of their reports through the AI-based tracking system. Any status changes or updates will be available in real-time, enhancing transparency and certainty in the case resolutio</p>
                                        <div class="text-left">
                                    <CButton class="b-20 button-transparent-171717 font-color-171717">Learn More <img src="../assets/img/smallicon/export.png" width="20px" /></CButton>
                                </div>
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/all/ai2.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/all/ai3.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Smart Crime Analytics
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        AI analyzes incoming report data to identify crime patterns and trends more accurately. With this technology, law enforcement can optimize prevention strategies and responses to crime based on data-driven insi.</p>
                                        <div class="text-left">
                                    <CButton class="b-20 button-transparent-171717 font-color-171717">Learn More <img src="../assets/img/smallicon/export.png" width="20px" /></CButton>
                                </div>
                                </CCol>
    
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Face Reaction Tracking
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Using facial expression monitoring technology, AI can analyze users' emotional reactions while making reports. This system helps detect inconsistencies or potential manipulation of information, thereby impro</p>
                                        <div class="text-left">
                                    <CButton class="b-20 button-transparent-171717 font-color-171717">Learn More <img src="../assets/img/smallicon/export.png" width="20px" /></CButton>
                                </div>
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/all/ai4.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                             
                            </CRow>
                        </div>
                    </CCol>
                </div>
            </CCol>
    
        </CCol>

        <!-- <CCol sm="12" class="bg-F5F5F5">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" class="responsive-90">
                        <div class="text-center">
                            <br /><br /><br />
    
                            <h1 class="custom-40px-600" data-aos="fade-left">
                                Testimonials & Success Stories
                            </h1>
                            <p class="custom-16px-400 text-center ml-4" data-aos="fade-right">Show feedback from police officers or citizens who have benefited from the AI</p>
                            <CRow class="m-0">
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "AI interview technology was a game-changer for me. As a recent graduate, I struggled to get noticed by employers."
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A1.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">John D</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "The AI interview process was incredibly thorough and fair. It evaluated my responses, body language, and even my..."
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A2.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">Emma W</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "It has significantly improved our ability to identify the right candidates by providing consistent, unbiased assessments”
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A3.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">Jason T</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
    
                                </CCol>
    
    
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "It has greatly improved our ability to find the right candidates quickly and accurately. The AI provides consistent.."
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A4.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">Maria S.</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "The AI provides consistent, unbiased evaluations, ensuring we find individuals who truly fit our requirements."
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A5.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">Michael T</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "The AI interview was a unique and enlightening experience. It highlighted aspects of my performance that I hadn't.."
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A6.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">Sophia R</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
    
                                </CCol>
    
                            </CRow>
                        </div>
                    </CCol>
    
                </div>
            </CCol>
        </CCol> -->

        <CCol sm="12">
            <CContainer>
                <br /><br />
                <CCol sm="12" style="background-size: cover;border-radius:20px" :style="{ backgroundImage: `url(${backgroundUrlExperience})` }">
                   <CRow>
                    <CCol sm="7">
                        <br />  <br />
                        <h3 class="custom-48px-600 text-white mt-3 mb-3">
                            Experience the Future of <br />
                            Police Reporting with AI!
                        </h3>
                        <br />  <br />
                    </CCol>
                    <CCol sm="5">
                        <br />  <br />
                        <div class="text-center mt-5">
                                    <CButton class="b-20 bg-white">Submit complaint</CButton>
                                    <CButton class="b-20 button-transparent text-white ml-2">Watch a demo video</CButton>
                                </div>
                    </CCol>
                   </CRow>
                </CCol>
                <br /><br />
            </CContainer>
        </CCol>
    
    
   
    
    
    
    
    
        <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/all/banner.png";
import backgroundUrlBox from "../assets/img/all/bg-box.png";
import backgroundUrlExperience from "../assets/img/all/bg-blue-black.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,
            backgroundUrlBox,
            backgroundUrlExperience,

            backgroundGenie,
            isActive: false,

            name: "",
            email: "",
            phone: "",
            password: "",
            selectedUser: "",


            isLanguagePopupVisible: false,
            emailinterest: "",

            selectedExpertise: "",
            selectedField: "",
            //selectedPosition: "",
            expertiseOptions: [], // Initialize as an empty array
            fieldOptions: [], // Initialize as an empty array
            positionOptions: [],
            isLanguagePopupVisible1: false,
            isLanguagePopupVisible2: false,

            Names: "",
            activetab: "",
            isLoved: false, // Initial state
            filter: false,
            hideColumn: true,

            isCategoryListVisible: true, // Toggle state
            isTypeListVisible: false,
            isCategorySeniorityVisible: false,
            categoryJob: [],
            categoryJobType: [],
            categoryJobSeniority: [],
            isLoved: false, // Initial state
            progressBarValue: 50, // Initial value (percentage)
            minSalary: 50000, // Example minimum salary
            maxSalary: 100000, // Example maximum salary
            companyCode: false,
            codeCompany: '',
            ErrorCode: false,
            ShowCode: false,
            Message: "",
            result: {},
            selectedPosition: '',
            ErrorPosition: false,
            user: null,
            Names: "",
        };

    },
    created() {
        AOS.init();

    },

    mounted() {
        this.getListField();
        this.getListExpertise();
        this.getListPosition();
        this.GetListCategoryJob();
        this.GetListCategoryJobType();
        this.GetListCategoryJobSeniority();
        setTimeout(this.TrackDailyVisit, 500);


        //   if (window.location.hostname !== "www.interviewrr.ai") {
        //  window.location.href = "https://www.interviewrr.ai";
        //  }  
    },
    computed: {
        popupClass() {
            return this.activetab === 'Career' ? 'popup-all1' : 'popup-all2';
        },
        progressBarWidth() {
            return `${this.progressBarValue}%`; // Convert value to percentage for width
        },
    },
    methods: {
        onCheckboxChange(event) {
            console.log('Checkbox changed:', event.target.checked);
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("Index");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("Index");
                console.error("Error fetching user info:", error);
            }
        },

        OpenFilter() {
            // this.filter = true;
            // this.hideColumn = false;

            this.filter = !this.filter;
            this.hideColumn = !this.hideColumn;

        },
        setActiveTab(tabName) {
            this.activetab = tabName;
        },


        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            //  this.$router.push("HowItWork");
            this.isLanguagePopupVisible1 = true;
        },
        OpenHowItWork() {
            this.$router.push("HowItWork");
        },
        GoToLogin() {
            this.$router.push("Login");
        },
        closePopup() {
            this.isLanguagePopupVisible1 = false;
        },
        closePopup1() {
            this.isLanguagePopupVisible1 = false;
        },
        closePopup2() {
            this.isLanguagePopupVisible1 = false;
            this.isLanguagePopupVisible2 = false;
        },
        OpenPopup() {
            this.isLanguagePopupVisible = false;
            this.isLanguagePopupVisible1 = true;

        },
        SubmitData() {
            const formData = new FormData();

            formData.append("email", this.emailinterest);
            formData.append("experties", this.selectedExpertise.Name);
            formData.append("field", this.selectedField.Name);


            this.$API
                .post(this.$RegisterInterest, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {

                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                                this.isLanguagePopupVisible1 = false;
                                this.isLanguagePopupVisible2 = true;

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        OpenFormVideo() {
            if (!this.selectedPosition || !this.selectedPosition.Name) {
                this.Message = 'Please select your current field';
                this.ErrorPosition = true;
            } else {
                if (this.ErrorCode === true) {
                    this.ErrorPosition = false;
                    this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name)
                } else {
                    if (this.codeCompany === '') {
                        this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name)

                    } else {
                        this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name + "&code=" + this.codeCompany)
                    }

                }


            }
        },
        async getListField() {
            try {
                const response = await this.$API.get(this.$GetListField);
                if (response.status === 200) {
                    this.fieldOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getListExpertise() {
            try {
                const response = await this.$API.get(this.$GetListExpertise);
                if (response.status === 200) {
                    this.expertiseOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getListPosition() {
            try {
                const response = await this.$API.get(this.$GetListPosition);
                if (response.status === 200) {
                    this.positionOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        OpenCalendly() {
            window.open("https://calendly.com/rasid-interviewrr");
        },
        toggleLove() {
            this.isLoved = !this.isLoved;
        },
        async GetListCategoryJob() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJob);
                if (response.status === 200) {
                    this.categoryJob = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleCategoryList() {
            this.isCategoryListVisible = !this.isCategoryListVisible;
        },

        async GetListCategoryJobType() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobType);
                if (response.status === 200) {
                    this.categoryJobType = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleTypeList() {
            this.isTypeListVisible = !this.isTypeListVisible;
        },

        async GetListCategoryJobSeniority() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobSeniority);
                if (response.status === 200) {
                    this.categoryJobSeniority = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleSeniorityList() {
            this.isCategorySeniorityVisible = !this.isCategorySeniorityVisible;
        },
        async VerifyCodeData() {
            try {
                this.ErrorPosition = false;
                const codeCompany1 = this.codeCompany;
                const response = await this.$API.get(this.$VerifyCode + '?code=' + codeCompany1); // Assuming this.$VerifyCode is your API endpoint URL

                if (response.status === 200) {
                    this.result = response.data;
                    if (this.result === 'The code is not ready for used.') {
                        this.Message = 'The code is not ready for used.';
                        this.ErrorCode = true;

                    } else if (this.result === 'The code is expired.') {
                        this.Message = 'The code is expired.';
                        this.ErrorCode = true;
                    } else if (this.result === 'The code is invalid.') {
                        this.Message = 'The code is invalid.';
                        this.ErrorCode = true;
                    } else {
                        this.Message = response.data
                        this.ShowCode = true;
                        this.ErrorCode = false;

                    }
                } else {
                    // Handle non-200 status code
                    console.error('Failed to fetch data:', response.statusText);
                }
            } catch (error) {
                // Handle the error here
                console.error('Error fetching data:', error);
            }
        },
        GoToVideo() {
            this.$router.push("VideoPlaylist");
        },
        TrackDailyVisit() {
            // Fetch the user's IP address using an external API (e.g., ipify)
            fetch('https://ipinfo.io/json')
                .then(response => response.json())
                .then(data => {
                    const userIp = data.ip; // Get the IP address

                    // Create FormData object
                    const formData = new FormData();

                    // Add visit data to the form
                    formData.append("Count", 1); // Increment by 1 for each visit
                    formData.append("IpAddress", userIp); // Add user's IP address

                    // API call to update the visit counter
                    this.$API
                        .post(this.$InsertCounterWebsite, formData)
                        .then((response) => {
                            if (response.status === 200) {
                                console.log("Visit recorded successfully");
                            }
                        })
                        .catch((error) => {
                            if (error.response) {
                                console.error("Error tracking visit:", error.response.status);
                                this.Error = true;
                                this.Message = "Error tracking visit";
                            }
                        });
                })
                .catch((error) => {
                    console.error("Error fetching IP address:", error);
                });
        },






    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.image-container {
    position: relative;
    max-width: 100%;
}

.background-image {
    width: 100%;
    height: auto;
}

.overlay-text {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    left: 20px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    background-color: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    color: white;
    padding: 10px;
    text-align: center;
    font-size: 1.2em;
    /* Adjust as needed */
    width: 70%;
    margin: 0 auto;
}

pre {
    white-space: pre-wrap;
    /* Ensures that newlines and spaces are rendered as expected */
    color: #171717;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 27px */
}

.bottom-right-button {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    right: 80px;
    /* Adjust as needed */
    padding: 10px 20px;
    background-color: #007bff;
    /* Button color */
    color: white;
    border: none;
    border-radius: 20px;
    cursor: pointer;
}

.bottom-right-button-text {
    position: absolute;
    bottom: 90px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    padding: 10px 20px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: #000;
    font-weight: 600;
}

.bottom-right-button:hover {
    background-color: #0056b3;
    /* Hover color */
}

/* .popup-all1 {
    width: 500px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 2%;
    height:70vh;
} */

.popup-all2 {
    width: 900px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 4%;
    z-index: 1;
    height: 90vh;
}

.salary-range {
    padding: 20px;
}

.progress {
    height: 20px;
    background-color: #e9ecef;
    border-radius: 4px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background-color: #007bff;
}

.custom-range {
    width: 100%;
}

.input-container {
    position: relative;
    display: inline-block;
    width: 100%;
}

input[type="text"].custom {
    padding-right: 60px;
    /* Adjust according to button width */
    height: 80px;
}

.verify-button {
    position: absolute;
    right: 2px;
    top: 3px;
    bottom: 3px;
    height: 28px;
    border-radius: 50px;
    background: #928AFD;
    color: #fff;
    /* Optional: Adjust the button height to match the input field */
}

.disabled {
    cursor: not-allowed;
    opacity: 0.5;
}
</style>